import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from '../hooks/useForm';
import profesionService from '../services/profesionService';
import '../styles/Professions.css';

const EditProfession = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const validateForm = (data) => {
    const errors = {};
    if (!data.PROFESION_NOMBRE?.trim()) errors.PROFESION_NOMBRE = 'Nombre requerido';
    if (!data.PROFESION_OBSERVACION?.trim()) errors.PROFESION_OBSERVACION = 'Descripción requerida';
    return errors;
  };

  const { formData, setFormData, errors, handleInputChange, validateForm: validate } = useForm({
    PROFESION_NOMBRE: '',
    PROFESION_OBSERVACION: ''
  }, validateForm);

  useEffect(() => {
    const loadProfesion = async () => {
      try {
        if (id) {
          setLoading(true);
          const profesiones = await profesionService.getAllProfesiones();
          const profesion = profesiones.find(p => p.PROFESION_ID === id);
          
          if (profesion) {
            setFormData({
              PROFESION_NOMBRE: profesion.PROFESION_NOMBRE || '',
              PROFESION_OBSERVACION: profesion.PROFESION_OBSERVACION || ''
            });
          } else {
            alert('Profesión no encontrada');
            navigate('/professions');
          }
        }
      } catch (error) {
        console.error('Error cargando profesión:', error);
        alert('Error al cargar los datos de la profesión');
      } finally {
        setLoading(false);
      }
    };

    loadProfesion();
  }, [id, setFormData, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        setLoading(true);
        await profesionService.updateProfesion(id, {
          PROFESION_NOMBRE: formData.PROFESION_NOMBRE,
          PROFESION_OBSERVACION: formData.PROFESION_OBSERVACION
        });
        alert('Profesión actualizada exitosamente');
        navigate('/professions');
      } catch (error) {
        console.error('Error actualizando profesión:', error);
        alert('Error al actualizar la profesión');
        setLoading(false);
      }
    }
  };

  const handleCancel = () => navigate('/professions');

  if (loading) return <div>Cargando...</div>;

  return (
    <div className="edit-profession-container">
      <h2>Editar Profesión</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nombre</label>
          <input
            name="PROFESION_NOMBRE"
            value={formData.PROFESION_NOMBRE}
            onChange={handleInputChange}
            className={errors.PROFESION_NOMBRE ? 'error' : ''}
          />
          {errors.PROFESION_NOMBRE && <span className="error-message">{errors.PROFESION_NOMBRE}</span>}
        </div>
        <div className="form-group">
          <label>Descripción</label>
          <textarea
            name="PROFESION_OBSERVACION"
            value={formData.PROFESION_OBSERVACION}
            onChange={handleInputChange}
            className={errors.PROFESION_OBSERVACION ? 'error' : ''}
          />
          {errors.PROFESION_OBSERVACION && <span className="error-message">{errors.PROFESION_OBSERVACION}</span>}
        </div>
        <div className="form-actions">
          <button type="submit" className="btn-primary">Actualizar</button>
          <button type="button" className="btn-secondary" onClick={handleCancel}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProfession;